module.exports = __webpack_public_path__ + "img/form-bg.6951b021.jpg";